import { render, staticRenderFns } from "./MediaSources.vue?vue&type=template&id=587697ec"
import script from "./MediaSources.vue?vue&type=script&lang=ts"
export * from "./MediaSources.vue?vue&type=script&lang=ts"
import style0 from "./MediaSources.vue?vue&type=style&index=0&id=587697ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports